/**
 * @deprecated This file is deprecated. Use ErrorBoundary from '../ui/ErrorBoundary' instead.
 * This file is kept for backward compatibility only.
 */

import React from 'react';
import { ErrorBoundary } from '../ui/ErrorBoundary';

// Legacy compatibility wrapper
export const SearchErrorBoundary: React.FC<{
  children: React.ReactNode;
  fallbackComponent?: React.ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
  showFallback?: boolean;
}> = ({
  children,
  fallbackComponent,
  onError,
  showFallback: _showFallback = true
}) => {
  return (
    <ErrorBoundary
      fallback={fallbackComponent}
      onError={onError}
      level="component"
      enableRetry={true}
    >
      {children}
    </ErrorBoundary>
  );
};

export default SearchErrorBoundary;